const AwsConfig = {
    bucketName: 'honda-assets',
    region: 'ap-south-1',
    accessKeyId: "AKIA46FSGXXRGREKPY4J",
    secretAccessKey: "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",

};

export default AwsConfig;
